import { Component, ChangeDetectionStrategy, effect, signal } from '@angular/core';
import { NgIf } from '@angular/common';
import { TabViewModule } from 'primeng/tabview';
import { YourPlanComponent } from './sections/your-plan/your-plan.component';

@Component({
   selector: 'app-account-management',
   standalone: true,
   imports: [NgIf, TabViewModule, YourPlanComponent],
   templateUrl: './account-management.component.html',
   styleUrls: ['./account-management.component.scss'],
   changeDetection: ChangeDetectionStrategy.OnPush
})
export class AccountManagementComponent {
   activeIndex = signal<number>(
      Number(localStorage.getItem('accountManagement.tab') ?? 0)
   );

   // persist tab between visits
   private _persist = effect(() => {
      localStorage.setItem('accountManagement.tab', String(this.activeIndex()));
   });
}
